import el from "@cypherpotato/el";
import { getSafeBounds } from "../ui/position";
import { Button } from "./button";
import { Icon } from "./icon";

export function Dropdown(text, ...items) {

    var source;
    var dropdown = el("div[popover=auto].dropdown-menu",
        ...items,
        {
            onBeforeToggle(event) {
                event.target.classList.remove("visible");
            },
            onToggle(event) {
                const size = event.target.getBoundingClientRect();
                const { x, y } = getSafeBounds(size.width, size.height, size.width / 2 * -1);
                
                event.target.style.top = y + "px";
                event.target.style.left = x + "px";
                event.target.classList.add("visible");
            }
        }
    );

    return Button(
        text,
        Icon("arrow-down-s-line"),
        {
            classList: ["dropdown"],
            onClick() {
                dropdown.togglePopover()
            },
            init() {
                source = this;
            }
        },
        dropdown
    );
}

export function DropdownItem(text, icon, ...args) {
    return el(".dropdown-item",
        icon,
        el("span", text),
        ...args,
        {
            onClick(event) {
                event.target.closest("[popover]").togglePopover(true);
            }
        }
    )
}

export function DropdownDivider() {
    return el(".dropdown-divider");
}